/**
 * Prazo da baixa do RT por nível (GUPM-184). TS puro.
 * Fiel ao protótipo: Atenção 48h / Alerta 24h / Emergência 12h, contados do
 * encaminhamento ao RT (`concluded_at`). Deriva o prazo — sem coluna no banco.
 */
import type { TarpLevel } from '../types';

/** Prazo (horas) para a baixa, por nível do TARP. */
export function prazoHorasPorNivel(nivel: TarpLevel): number {
  if (nivel === 'EMERGENCIA') return 12;
  if (nivel === 'ALERTA') return 24;
  return 48; // Atenção (e demais) — janela padrão
}

export interface PrazoBaixa {
  /** Horas restantes até o prazo (negativo = estourado). */
  restanteH: number;
  estourado: boolean;
}

/**
 * Prazo restante da baixa, contado de `concluded_at` (encaminhamento ao RT).
 * `null` se a TARP ainda não foi encaminhada.
 */
export function calcPrazoBaixa(
  concludedAtISO: string | null,
  nivel: TarpLevel,
  agoraISO: string,
): PrazoBaixa | null {
  if (!concludedAtISO) return null;
  const decorridoH =
    (new Date(agoraISO).getTime() - new Date(concludedAtISO).getTime()) / 3_600_000;
  const restanteH = prazoHorasPorNivel(nivel) - decorridoH;
  return { restanteH, estourado: restanteH < 0 };
}
